// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var TipBox = require("../../../uikit/atoms/TipBox/TipBox.bs.js");
var Spinner = require("../../../uikit/reason/atoms/Spinner/Spinner.bs.js");
var Core__Int = require("@rescript/core/src/Core__Int.bs.js");
var TimePicker = require("../../../reason/common/DateAndTime/TimePicker.bs.js");
var Form__Label = require("../../../uikit/reason/atoms/Form/Form__Label.bs.js");
var Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
var RichTextEditorV5 = require("../../common/Components/RichTextEditorV5.bs.js");
var JsxRuntime = require("react/jsx-runtime");

function PropertyWizardFormRelay__Elements$IntInputField(props) {
  var onChange = props.onChange;
  return JsxRuntime.jsx(Form__Components.TextInputField.make, {
              value: props.value,
              onBlur: props.onBlur,
              onFocus: props.onFocus,
              onChange: (function (evt) {
                  onChange(Core__Int.fromString(evt.target.value, undefined));
                }),
              validationResult: props.validationResult,
              labelText: props.label,
              optionalText: props.optionalText,
              append: props.append
            });
}

var IntInputField = {
  make: PropertyWizardFormRelay__Elements$IntInputField
};

function PropertyWizardFormRelay__Elements$LoadingSpinner(props) {
  return JsxRuntime.jsx("div", {
              children: JsxRuntime.jsx(Spinner.make, {}),
              className: "absolute right-[9px] bottom-[7px] w-[21px] h-[21px] flex items-center justify-center"
            });
}

var LoadingSpinner = {
  make: PropertyWizardFormRelay__Elements$LoadingSpinner
};

function PropertyWizardFormRelay__Elements$RichTextEditorField(props) {
  var onChange = props.onChange;
  return JsxRuntime.jsx(RichTextEditorV5.make, {
              initialContent: props.initialContent,
              onChangeFull: (function (value) {
                  onChange(value);
                }),
              onBlur: props.onBlur,
              onFocus: props.onFocus,
              toolbar: props.toolbar,
              height: props.height,
              status: props.status,
              labelText: props.labelText,
              optionalText: props.optionalText,
              helpText: props.helpText,
              placeholderText: props.placeholderText,
              editorRef: props.forwardRef
            });
}

var RichTextEditorField = {
  RichTextEditor: undefined,
  make: PropertyWizardFormRelay__Elements$RichTextEditorField
};

function PropertyWizardFormRelay__Elements$TimePicker(props) {
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(Form__Label.make, {
                      labelText: props.label
                    }),
                JsxRuntime.jsx(TimePicker.make, {
                      placeholder: props.placeholder,
                      value: props.value,
                      onChange: props.onChange,
                      startTime: props.startTime,
                      endTime: props.endTime,
                      onBlur: props.onBlur,
                      onFocus: props.onFocus,
                      hourlyIntervals: props.hourlyIntervals,
                      isClearable: props.isClearable
                    })
              ]
            });
}

var TimePicker$1 = {
  make: PropertyWizardFormRelay__Elements$TimePicker
};

function PropertyWizardFormRelay__Elements$RebroadcastMessageTipBox(props) {
  return JsxRuntime.jsx(TipBox.make, {
              title: "Message for TAN colleagues",
              children: JsxRuntime.jsx("p", {
                    children: "Tell your TAN colleagues why you're rebroadcasting this property. This message is not shared with clients."
                  })
            });
}

var RebroadcastMessageTipBox = {
  make: PropertyWizardFormRelay__Elements$RebroadcastMessageTipBox
};

function PropertyWizardFormRelay__Elements$RebroadcastHeadlineTipBox(props) {
  return JsxRuntime.jsx(TipBox.make, {
              title: "Headline",
              children: JsxRuntime.jsxs(JsxRuntime.Fragment, {
                    children: [
                      JsxRuntime.jsx("p", {
                            children: "Enter a new headline that summarizes why you are rebroadcasting this property."
                          }),
                      JsxRuntime.jsx("p", {
                            children: "Examples: Photos are in! Designer unit 50 Liberty, Available this weekend by appointment, BOM, Major price drop coming soon."
                          })
                    ]
                  })
            });
}

var RebroadcastHeadlineTipBox = {
  make: PropertyWizardFormRelay__Elements$RebroadcastHeadlineTipBox
};

var TipBox$1;

exports.IntInputField = IntInputField;
exports.LoadingSpinner = LoadingSpinner;
exports.RichTextEditorField = RichTextEditorField;
exports.TimePicker = TimePicker$1;
exports.TipBox = TipBox$1;
exports.RebroadcastMessageTipBox = RebroadcastMessageTipBox;
exports.RebroadcastHeadlineTipBox = RebroadcastHeadlineTipBox;
/* TipBox Not a pure module */
